import { ConnectionMode } from '../types';
import type { HandleBound, HandleBounds } from '../types';

/** The handle with `id`; with no id (or a single candidate) the first one — v11 rules. */
export const getHandle = (candidates: readonly HandleBound[], id: string | null | undefined): HandleBound | null => {
  if (candidates.length === 0) return null;
  if (candidates.length === 1 || !id) return candidates[0];
  return candidates.find((handle) => handle.id === id) ?? null;
};

/**
 * Handles an edge connects. In loose mode the target may be any handle of the target node, including a
 * source handle (the app's handles are all sources). Null when either end has no matching handle.
 */
export const getEdgeHandles = (
  sourceBounds: HandleBounds | null,
  targetBounds: HandleBounds | null,
  sourceHandleId: string | null | undefined,
  targetHandleId: string | null | undefined,
  connectionMode: ConnectionMode,
): { source: HandleBound; target: HandleBound } | null => {
  if (!sourceBounds || !targetBounds) return null;
  const targetCandidates =
    connectionMode === ConnectionMode.Strict ? targetBounds.target : [...targetBounds.target, ...targetBounds.source];
  const source = getHandle(sourceBounds.source, sourceHandleId);
  const target = getHandle(targetCandidates, targetHandleId);
  return source && target ? { source, target } : null;
};
